import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from './material.module';
import { BooleanToStringPipe } from '@pipes/boolean-to-string.pipe';
import { SafePipe } from '@pipes/safe.pipe';

@NgModule({
    imports: [
        MaterialModule,
        FlexLayoutModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    exports: [
        MaterialModule,
        FlexLayoutModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        BooleanToStringPipe,
        SafePipe
    ],
    declarations: [
        BooleanToStringPipe,
        SafePipe
    ]
})
export class CoreModule { }
